var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConvert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3.8625V6.6375C16.5 8.325 15.825 9 14.1375 9H12.1125C10.425 9 9.75 8.325 9.75 6.6375V3.8625C9.75 2.175 10.425 1.5 12.1125 1.5H14.1375C15.825 1.5 16.5 2.175 16.5 3.8625Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 11.3625V14.1375C8.25 15.825 7.575 16.5 5.8875 16.5H3.8625C2.175 16.5 1.5 15.825 1.5 14.1375V11.3625C1.5 9.675 2.175 9 3.8625 9H5.8875C7.575 9 8.25 9.675 8.25 11.3625Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0871 16.5001C10.8846 16.5001 10.6971 16.3876 10.5996 16.2151C10.5021 16.0351 10.5021 15.8251 10.6071 15.6451L11.3346 14.4301C11.4921 14.1601 11.8371 14.0776 12.1071 14.2351C12.3771 14.3926 12.4596 14.7376 12.3021 15.0076L12.1671 15.2326C14.0196 14.7526 15.3846 13.0726 15.3846 11.0776C15.3846 10.7701 15.6396 10.5151 15.9471 10.5151C16.2546 10.5151 16.5021 10.7701 16.5021 11.0851C16.5021 14.0701 14.0721 16.5001 11.0871 16.5001Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0625 7.4775C1.755 7.4775 1.5 7.23 1.5 6.915C1.5 3.93 3.93 1.5 6.915 1.5C7.125 1.5 7.305 1.6125 7.41 1.785C7.5075 1.965 7.5075 2.175 7.4025 2.355L6.675 3.5625C6.51 3.8325 6.165 3.9225 5.9025 3.7575C5.6325 3.6 5.55 3.255 5.7075 2.985L5.8425 2.76C3.9975 3.24 2.625 4.92 2.625 6.915C2.625 7.23 2.37 7.4775 2.0625 7.4775Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvert);
export default __webpack_public_path__ + "static/media/convert.ff29d67fbccbefa1b2f9b8df490e9217.svg";
export { ForwardRef as ReactComponent };